import InfoCard from '@src/components/InfoCard';
import { useAuthenticationContext } from '@src/contexts';

import { IWebinarAttendees } from '@src/webinar/types';

import styles from '../webinarAttendees.module.scss';

interface Props {
  data: IWebinarAttendees;
}

const AttendeesCards = ({ data }: Props) => {
  const testComponentId = 'attendsCard';
  const { handleRedirect } = useAuthenticationContext();

  return (
    <div className={styles['attends-cards-container']} id={`${testComponentId}_container`}>
      <InfoCard>
        <InfoCard.Title>Total registered</InfoCard.Title>
        <InfoCard.Content>
          <div className={styles['info-column']}>
            <span className={styles['info-column-label']}>Attendance</span>
            <span className={styles['info-column-value']} id={`${testComponentId}_totalRegistered`}>
              {(data.totalRegistered ?? 0).toLocaleString()}
            </span>
          </div>
        </InfoCard.Content>
      </InfoCard>
      <InfoCard>
        <InfoCard.Title>Attendance</InfoCard.Title>
        <InfoCard.Content>
          <div className={styles['info-columns']}>
            <div className={styles['info-column']}>
              <span className={styles['info-column-label']}>
                Approved <small>{`(out of ${data.package?.attendanceLimit ?? 0})`}</small>
              </span>
              <span className={styles['info-column-value']} id={`${testComponentId}_totalApproved`}>
                {(data.attendance?.approved ?? 0).toLocaleString()}
              </span>
            </div>
            <div className={styles['info-column']}>
              <span className={styles['info-column-label']}>Rejected</span>
              <span className={styles['info-column-value']} id={`${testComponentId}_totalRejected`}>
                {(data.attendance?.rejected ?? 0).toLocaleString()}
              </span>
            </div>
            <div className={styles['info-column']}>
              <span className={styles['info-column-label']}>Pending</span>
              <span className={styles['info-column-value']} id={`${testComponentId}_totalPending`}>
                {(data.attendance?.pending ?? 0).toLocaleString()}
              </span>
            </div>
          </div>
        </InfoCard.Content>
      </InfoCard>
      <InfoCard>
        <InfoCard.Title>
          Panel list <small>{`(out of ${data.package?.panelistsLimit || 0})`}</small>
        </InfoCard.Title>
        <InfoCard.Content>
          <div className={styles['info-columns']}>
            <div className={styles['info-column']}>
              <span className={styles['info-column-label']}>Speakers</span>
              <span className={styles['info-column-value']}>{(data.panelList?.speakers ?? 0).toLocaleString()}</span>
            </div>
            <div className={styles['info-column']}>
              <span className={styles['info-column-label']}>Co-hosts</span>
              <span className={styles['info-column-value']}>{(data.panelList?.co_hosts ?? 0).toLocaleString()}</span>
            </div>
          </div>
        </InfoCard.Content>
      </InfoCard>
      <InfoCard>
        <InfoCard.Title
          action={
            <button
              onClick={() => {
                handleRedirect();
              }}
              rel="noopener noreferrer"
              className={styles['card-link']}
            >
              Upgrade
            </button>
          }
        >
          Package capacity
        </InfoCard.Title>
        <InfoCard.Content>
          <div className={styles['info-column']}>
            <span className={styles['info-column-label']}>Attendance</span>
            <span className={styles['info-column-value']}>
              {(data.package?.attendanceLimit ?? 0).toLocaleString()}{' '}
            </span>
          </div>
        </InfoCard.Content>
      </InfoCard>
    </div>
  );
};

export default AttendeesCards;
